import React from 'react'
import { Button } from '@mui/material'
import ArchiveIcon from '@mui/icons-material/Archive'

import {
  useDownloadJournalReconAllReportsZipLazyQuery
} from '../../../../api-services/financial/journalReconApi'
import { RtkQueryHelper } from '../../../../api-services/shared/RtkQueryHelper'
import { useAppDispatch } from '../../../../app/hooks'
import { setNotification } from '../../../components/ui-widgets/uiWidgetsSlice'
import ButtonLoadingComponent from '../../../../views/components/shared/ButtonLoadingComponent'

interface Props {
  startDate: string
  disabled: boolean
}

const DownloadJournalReconZipButton: React.FC<Props> = ({ startDate, disabled }) => {
  const dispatch = useAppDispatch()
  const [trigger, { isFetching }] = useDownloadJournalReconAllReportsZipLazyQuery()

  const handleDownload = (): void => {
    trigger(startDate)
      .unwrap()
      .then((result) => {
        const url = URL.createObjectURL(result.blob)
        const link = document.createElement('a')
        link.href = url
        link.download = result.filename
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
      })
      .catch((err) => {
        dispatch(setNotification({ open: true, severity: 'error', message: RtkQueryHelper.mapResponseError(err) }))
      })
  }

  return (
    <Button
      variant={'contained'}
      color={'primary'}
      disabled={disabled || isFetching}
      startIcon={<ArchiveIcon />}
      onClick={handleDownload}
    >
      Download All CSVs (ZIP)
      { isFetching && <ButtonLoadingComponent /> }
    </Button>
  )
}

export default DownloadJournalReconZipButton
